import React from 'react';
import Modal from './Modal';
import IPadModalContent from './ModalContent/IpadModalContent';
import IpadMiniModalContent from './ModalContent/IpadMiniModalContent';
import ReceiptPrinterModalContent from './ModalContent/ReceiptPrinterModalContent';
import PaymentTerminalModalContent from './ModalContent/PaymentTerminalModalContent';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';
import Register from 'features/POSRegisters/interfaces/Register';
import TypedDevice from 'features/POSRegisters/interfaces/TypedDevice';
import {AdaptedDeviceData} from 'features/POSRegisters/interfaces/AdaptedDeviceData';
import ScanDetails from 'features/POSRegisters/interfaces/ScanDetails';
import UnsupportedModalContent from './ModalContent/UnsupportedModalContent';

function renderModalContent(
  deviceType: DeviceType | null,
  adaptedDeviceData: AdaptedDeviceData<ScanDetails> | null
) {
  let modalType: DeviceType | string | null = deviceType;

  if (deviceType !== null && adaptedDeviceData !== null) {
    if (adaptedDeviceData[deviceType]?.scanResults?.isSupported === false) {
      modalType = 'unsupported';
    }
  }

  switch (modalType) {
    case DeviceType.IPAD:
      return (
        <IPadModalContent deviceType={DeviceType.IPAD} adaptedDeviceData={adaptedDeviceData} />
      );
    case DeviceType.IPAD_MINI:
      return (
        <IpadMiniModalContent
          deviceType={DeviceType.IPAD_MINI}
          adaptedDeviceData={adaptedDeviceData}
        />
      );
    case DeviceType.RECEIPT_PRINTER:
      return (
        <ReceiptPrinterModalContent
          deviceType={DeviceType.RECEIPT_PRINTER}
          adaptedDeviceData={adaptedDeviceData}
        />
      );
    case DeviceType.PAYMENT_TERMINAL:
      return (
        <PaymentTerminalModalContent
          deviceType={DeviceType.PAYMENT_TERMINAL}
          adaptedDeviceData={adaptedDeviceData}
        />
      );
    case 'unsupported':
      return (
        <UnsupportedModalContent
          deviceType={deviceType ? deviceType : DeviceType.REGISTER}
          adaptedDeviceData={adaptedDeviceData}
        />
      );
    default:
      return <>Unhandled DeviceType</>;
  }
}

function adaptDeviceData(
  register?: Register,
  typedDevice?: TypedDevice<any>
): AdaptedDeviceData<ScanDetails> | null {
  if (register) {
    return {
      ...register,
    };
  }

  if (typedDevice) {
    return {
      id: '',
      [typedDevice.type]: typedDevice,
    } as AdaptedDeviceData<ScanDetails>;
  }

  return null;
}

interface DeviceModalProps {
  selectedDevice: DeviceType | null;
  register?: Register;
  typedDevice?: TypedDevice<any>;
  modalState: boolean;
  handleClose: () => void;
}

export default function DeviceModal({
  selectedDevice,
  register,
  typedDevice,
  modalState,
  handleClose,
}: DeviceModalProps) {
  const deviceData = adaptDeviceData(register, typedDevice);
  return (
    <Modal open={modalState} onClose={handleClose}>
      {renderModalContent(selectedDevice, deviceData)}
    </Modal>
  );
}
